import PropTypes from 'prop-types';
import { AspectRatio, Grid, Stack } from '@chakra-ui/layout';
import { Skeleton, SkeletonText } from '@chakra-ui/skeleton';
import React from 'react';

export const ProductCardSkeleton = ({ isActive = true }) => (
  <Stack spacing={3}>
    <AspectRatio ratio={1}>
      <Skeleton borderRadius="xl" speed={isActive ? undefined : 0} />
    </AspectRatio>
    <SkeletonText noOfLines={3} spacing={3} speed={isActive ? undefined : 0} />
  </Stack>
);

ProductCardSkeleton.propTypes = {
  isActive: PropTypes.bool,
};

export const ProductGridSkeleton = () => (
  <Grid
    templateColumns={[
      'repeat(2, minmax(0, 1fr))',
      'repeat(2, minmax(0, 1fr))',
      'repeat(4, minmax(0, 1fr))',
    ]}
    gap={4}
  >
    <ProductCardSkeleton />
    <ProductCardSkeleton />
    <ProductCardSkeleton />
    <ProductCardSkeleton />

    <ProductCardSkeleton />
    <ProductCardSkeleton />
    <ProductCardSkeleton />
    <ProductCardSkeleton />

    <ProductCardSkeleton />
    <ProductCardSkeleton />
    <ProductCardSkeleton />
  </Grid>
);
